<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-button (click)="onClose()"
        ><ion-icon name="arrow-back-outline" slot="icon-only"> </ion-icon
      ></ion-button>
    </ion-buttons>
    <ion-title>{{ vet.name }}</ion-title>
  </ion-toolbar></ion-header
>
<ion-content color="lightmimbo">
  <ion-list>
    <ion-item *ngFor="let day of vet.openingHours" color="lightmimbo">
      <ion-text>{{ day }}</ion-text>
    </ion-item>
  </ion-list>
</ion-content>
